import "./accordion.css";
import { useState } from "react";

function Accordion(){

   return(
    <div className="accordion">
        <h1>שירותי תיקון נפוצים</h1>
        <ul>
            <li>
                <input type="checkbox" checked="false"/>
                <i></i>
                <h2>הפסקות חשמל</h2>
               <p>במידה ואתם מתמודדים עם הפסקת חשמל, כדאי לבדוק האם הפסקת החשמל היא גם אצל השכנים או רק בבתיכם. במידה וההפסקת חשמל היא גם אצל השכנים כנראה שחברת החשמל דואגת לכך שהחשמל ישוב לפעול בהקדם. במידה והפסקת החשמל היא רק בביתכם, אשמח להגיע ולסייע בפתרון הבעיה.</p>
            </li>
            <li>
                <input type="checkbox" checked="false"/>
                <i></i>
                <h2>מפסקי פחת</h2>
                <p>תפקידו של מפסק הפחת במערכת החשמל חשוב ביותר והוא למנוע התחשמלות על ידי זיהוי זליגת חשמל מאחד המכשירים. במצב כזה, מפסק הפחת מנתק אוטומטית את אספקת החשמל ללוח וכך מונע תקלות חשמליות. אם משהו השתבש בחשמל שלכם, המקום הראשון שיש לבדוק הוא את מפסק הפחת שנמצא בלוח החשמל. להמשך טיפול והתייעצות בנושא ניתן לפנות אליי.</p>
            </li>
            <li>
                <input type="checkbox" checked="false"/>
                <i></i>
                <h2>תיקון לוחות חשמל</h2>
              <p>לוח חשמל תקין הינו פריט חיוני היכול להציל חיי אדם במקרה של התחשמלות, כאשר מעוניינים להתקין לוח חשמל או לערוך תחזוקת לוחות חשמל בכל מבנה, חובה להזמין חשמלאי מוסמך, בעל ניסיון עשיר בכדי שיבצע את התקנת הלוח וחלוקה נכונה באופן המקצועי ביותר. כאשר מכשירי החשמל אינם פועלים בקיבולת מלאה, או כאשר האורות שלך מהבהבים באופן בלתי צפוי, ישנם מספר סימנים נוספים לכך שייתכן שתזדקקו לתיקון לוח החשמל שלכם. לעתים נגלה כי מדובר בתיקון נקודתי בלבד אשר יוכל לפתור את התקלה. במקרים אחרים, ייתכן ומצבו של לוח החשמל כמו גם היותו מיושן, יצריך החלפה כללית מלאה.</p>
            </li>
            <li>
                <input type="checkbox" checked="false"/>
                <i></i>
                <h2>מתגים חשמליים</h2>
              <p>מתגים ושקעי חשמל חיוניים לתפקוד הבית, דרכם נוכל להדליק ולכבות את מכשירי החשמל שלנו. כאשר יש לך מתגים ושקעים לא תקינים בביתך, אנו מציעים מתגי חשמל ושירותי תיקון שקעים כדי לספק אספקת חשמל בטוחה ופונקציונלית.</p>
            </li>
            <li>
                <input type="checkbox" checked="false"/>
                <i></i>
                <h2>התקנת תשתיות לבית חכם</h2>
              <p>על מנת שנוכל להתאים את הבית שלנו לטכנולוגיה המתקדמת, בזמן בניית מבנה חדש או שדרוג הבית ניתן להכין תשתית שמתאימה לבית חכם. בית חכם הוא בית שפועל על ידי מערכת המאפשרת לשלוט על מספר מוצרי חשמל בו זמנית באמצעות מפסק אחד. את מערכת הבית החכם ניתן להפעיל אפילו כאשר אתם מחוץ לבית והיא תאפשר לכם נוחות מתקדמת. מעוניינים לשמוע פרטים נוספים? חייגו אלי ואשמח לסייע.</p>
            </li>
            <li>
                <input type="checkbox" checked="false"/>
                <i></i>
                <h2>עמדות טעינה לרכב חשמלי</h2>
              <p>רכבים חשמליים מקנים לנו יתרונות רבים וביניהם את היתרון המרכזי- להטעין את הרכב בעמדה ממש מחוץ לבית או לבניין. מה שמאפשר טעינה מלאה של הרכב בכל חזרה הביתה ובין היתר טעינה ביתית היא משמעותית כלכלית יותר מאשר טעינה של מטענים חשמליים בחוץ. על מנת שנוכל ליצור עמדה טעינה לרכב החשמלי שלך, ראשית עלינו להבין את צרכיך ובהתאם לכך נוכל לתכנן תשתית ולפרוס אותה. להתייעצות בנושא ניתן לחייג אלי ואשמח לסייע.</p>
            </li>
        </ul>
    </div>
   )
    
};

export default Accordion;



  